<itl-text
  [(ngModel)]="text"
  [title]="node.title"
  [required]="node.mandatory"
  [description]="node.description"
  [maxlength]="showCharacterLimit ? characterLimit : null"
  [icon]="node.globalType ? (node.globalType | globalTypeIcon) : null"
>
</itl-text>
